import './loading.scss';
import map from '../map';

let el = document.getElementById('loading');

// respond to loading events from the rest of the app
map.on('loading.start', function(){
    el.classList.add('on');
});
map.on('loading.end', function(){
    el.classList.remove('on');
});



// WEBPACK FOOTER //
// ./src/js/loading/loading.js